import styled from 'styled-components';

import { Box } from '@sternum/styled-system';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const MenuSectionStyled = styled.div`
  margin-top: 16px;
`;

export const MenuSectionTitle = styled.div`
  display: flex;
  align-items: center;
  padding-left: 24px;
  margin-bottom: 20px;
  font-size: 10px;
  font-weight: 600;
  color: ${ct({ Dark: Colors.GreyDarker, Light: Colors.GreyDarker })};
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const MenuContent = styled(Box)`
  display: flex;
  flex-flow: column;
  gap: 8px;
  padding: 0 12px;
`;
